import { CONFIG } from 'src/config-global';

export function normalizeChain(
  chain?: string | null
): 'ETHEREUM' | 'BITCOIN' | 'SOLANA' | 'TRON' | 'BSC' | 'POLYGON' | 'BITCOIN_CASH' | 'LITECOIN' | 'ROBINHOOD' {
  const normalized = chain?.toUpperCase();

  if (normalized === 'BTC' || normalized === 'BITCOIN') {
    return 'BITCOIN';
  }

  if (normalized === 'BCH' || normalized === 'BITCOIN_CASH') {
    return 'BITCOIN_CASH';
  }

  if (normalized === 'LTC' || normalized === 'LITECOIN') {
    return 'LITECOIN';
  }

  if (normalized === 'SOL' || normalized === 'SOLANA') {
    return 'SOLANA';
  }

  if (normalized === 'TRX' || normalized === 'TRON') {
    return 'TRON';
  }

  if (normalized === 'BSC' || normalized === 'BNB') {
    return 'BSC';
  }

  if (normalized === 'POLYGON' || normalized === 'POL') {
    return 'POLYGON';
  }

  if (normalized === 'ROBINHOOD' || normalized === 'HOOD') {
    return 'ROBINHOOD';
  }

  return 'ETHEREUM';
}

const chainTokenPng = (
  chain?: string | null
): 'ETH' | 'BTC' | 'SOL' | 'TRON' | 'BNB' | 'POL' | 'BCH' | 'LTC' | 'ROBINHOOD' | null => {
  const n = chain?.toUpperCase();
  if (n === 'ETHEREUM' || n === 'ETH') return 'ETH';
  if (n === 'BITCOIN' || n === 'BTC') return 'BTC';
  if (n === 'BITCOIN_CASH' || n === 'BCH') return 'BCH';
  if (n === 'LITECOIN' || n === 'LTC') return 'LTC';
  if (n === 'SOLANA' || n === 'SOL') return 'SOL';
  if (n === 'TRON' || n === 'TRX') return 'TRON';
  if (n === 'BSC' || n === 'BNB') return 'BNB';
  if (n === 'POLYGON' || n === 'POL') return 'POL';
  if (n === 'ROBINHOOD' || n === 'HOOD') return 'ROBINHOOD';
  return null;
};

const chainTokenAlt = (chain?: string | null): string => {
  const n = chainTokenPng(chain);
  if (n) return n;
  return 'Chain';
};

/**
 * Public URL for chain token art (e.g. ETH.png). Use root-relative or CDN base from
 * VITE_ASSETS_DIR so icons resolve on nested routes (e.g. /dashboard/overview) and
 * in staging with an asset CDN; relative `assets/...` paths break under client routing.
 */
export function chainTokenIconUrl(chain?: string | null): string | null {
  const file = chainTokenPng(chain);
  if (!file) return null;
  const path = `assets/icons/tokens/${file}.png`;
  const base = CONFIG.assetsDir;
  if (!base) {
    return `/${path}`;
  }
  return `${base.replace(/\/$/, '')}/${path}`;
}

export function chainTokenIconAltText(chain?: string | null): string {
  return chainTokenAlt(chain);
}

/** Prefer chain token art for Robinhood (native asset is ETH but chain-branded icon). */
export function mintTokenIconUrl(mint: {
  img?: string | null;
  chain?: string | null;
}): string | null {
  const chain = mint.chain?.toUpperCase();
  if (chain === 'ROBINHOOD' || chain === 'HOOD') {
    return chainTokenIconUrl(mint.chain) ?? mint.img ?? null;
  }
  return mint.img ?? chainTokenIconUrl(mint.chain) ?? null;
}
